import { CircularProgress } from "@material-ui/core";

import React from "react";

const LoadingButton = ({ isLoading, children }) =>
	isLoading ? <CircularProgress size={14} /> : children;

export default LoadingButton;
